/* D16 · Header navigation behaviour (Oct 2026). Loaded only with D16 on.
   1. Desktop dropdowns close with a short fade instead of snapping shut: the theme's HeaderMenu.close()
      (outside click, focus leaving) and a click on the open item both wait for the close animation.
      Escape still closes at once, which is what keyboard users expect. Opening a second menu closes
      the first at once, so two panels never overlap.
   2. Phone menu (below 990 px, snippets/dz-nav-phone.liquid): opens under the header, closes on the pill,
      a tap on the dimmed page or Escape (focus back to the pill), and holds the page still while open.
   3. Product photos in the menus are lazy; they are decoded in idle time after load and switched to eager
      the moment a pointer or focus reaches a menu, so a menu never opens on empty squares. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const OUT_MS = 120;
  
  function closeAnimated(details, done) {
    if (reduce.matches || !details.hasAttribute('open') || details.classList.contains('dz-closing')) {
      done();
      return;
    }
    details.classList.add('dz-closing');
    window.setTimeout(() => {
      details.classList.remove('dz-closing');
      done();
    }, OUT_MS);
  }

  customElements.whenDefined('header-menu').then(() => {
    const proto = customElements.get('header-menu').prototype;
    const close = proto.close;
    proto.close = function () {
      closeAnimated(this.mainDetailsToggle, () => close.call(this));
    };
  });

  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest('.dz-nav-menu details > summary');
      if (!summary) return;
      const details = summary.parentElement;
      if (!details.hasAttribute('open')) {
        document.querySelectorAll('.dz-nav-menu details[open]').forEach((other) => {
          if (other === details) return;
          other.classList.remove('dz-closing');
          other.removeAttribute('open');
          other.querySelector('summary').setAttribute('aria-expanded', 'false');
        });
        return;
      }
      if (reduce.matches) return;
      event.preventDefault();
      closeAnimated(details, () => details.removeAttribute('open'));
    },
    true
  );

  const pm = document.querySelector('[data-dz-pm]');
  if (pm) {
    const toggle = pm.querySelector('summary');
    const header = document.querySelector('.section-header') || document.querySelector('header');
    const setTop = () => {
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--dz-pm-top', bottom + 'px');
    };
    const close = (refocus) =>
      closeAnimated(pm, () => {
        pm.removeAttribute('open');
        if (refocus) toggle.focus();
      });
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', (event) => {
      if (pm.hasAttribute('open')) {
        event.preventDefault();
        close(false);
      } else {
        setTop();
        warm();
      }
    });
    pm.addEventListener('toggle', () => {
      toggle.setAttribute('aria-expanded', String(pm.open));
      document.documentElement.classList.toggle('dz-pm-open', pm.open);
    });
    pm.querySelector('[data-dz-pm-close]').addEventListener('click', () => close(false));
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !pm.open) return;
      pm.removeAttribute('open');
      toggle.focus();
    });
    window.addEventListener('resize', () => pm.open && setTop());
  }

  let warmed = false;
  function warm() {
    if (warmed) return;
    warmed = true;
    document.querySelectorAll('.dz-nav-product__img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
      if (img.decode) img.decode().catch(() => {});
    });
  }
  // Decode the menu photos while the page is idle, so opening a menu never waits on them
  const idle = window.requestIdleCallback || ((fn) => window.setTimeout(fn, 1500));
  window.addEventListener('load', () => idle(warm, { timeout: 4000 }), { once: true });
  const triggers = '.dz-nav-menu summary, .dz-pm__toggle';
  ['pointerenter', 'focusin', 'touchstart'].forEach((type) => {
    document.addEventListener(
      type,
      (event) => {
        if (event.target instanceof Element && event.target.closest(triggers)) warm();
      },
      { capture: true, passive: true }
    );
  });
})();
